// ── Color palette ─────────────────────────────────────────────────────────────
export const COLORS = {
  purple: ["#EEEDFE","#CECBF6","#AFA9EC","#7F77DD","#534AB7","#3C3489","#26215C"],
  teal:   ["#E1F5EE","#9FE1CB","#5DCAA5","#1D9E75","#0F6E56","#085041","#04342C"],
  coral:  ["#FAECE7","#F5C4B3","#F0997B","#D85A30","#993C1D","#712B13","#4A1B0C"],
  amber:  ["#FAEEDA","#FAC775","#EF9F27","#BA7517","#854F0B","#633806","#412402"],
  blue:   ["#E6F1FB","#B5D4F4","#85B7EB","#378ADD","#185FA5","#0C447C","#042C53"],
  green:  ["#EAF3DE","#C0DD97","#97C459","#639922","#3B6D11","#27500A","#173404"],
  gray:   ["#F1EFE8","#D3D1C7","#B4B2A9","#888780","#5F5E5A","#444441","#2C2C2A"],
};

// ── Event code → display metadata ─────────────────────────────────────────────
// Extend this map as you add new event codes to the backend.
export const EVENT_META = {
  1001: { name: "App Opened",              color: COLORS.purple[3], source: "system" },
  1002: { name: "Language Selected",       color: COLORS.blue[3],   source: "user"   },
  1004: { name: "Login Attempted",         color: COLORS.amber[3],  source: "user"   },
  1006: { name: "OTP Verified",            color: COLORS.teal[3],   source: "system" },
  1301: { name: "Home Viewed",             color: COLORS.blue[4],   source: "system" },
  1302: { name: "Home Card Clicked",       color: COLORS.amber[4],  source: "user"   },
  1401: { name: "Vital Screen Viewed",     color: COLORS.purple[4], source: "system" },
  1403: { name: "Vital Realtime Measured", color: COLORS.teal[4],   source: "device" },
};

// ── Source badge colors ───────────────────────────────────────────────────────
export const SOURCE_COLORS = {
  system: COLORS.gray[3],
  user:   COLORS.blue[3],
  device: COLORS.teal[3],
};

// ── Date range options ────────────────────────────────────────────────────────
export const DATE_RANGES = ["7d", "30d", "90d"];

// ── Tab definitions ───────────────────────────────────────────────────────────
export const TABS = ["Overview", "Features", "Screens", "Journeys", "Live Feed"];

// ── Feature events ────────────────────────────────────────────────────────────
export const FEATURE_EVENT_KEYS = [
  "CHAT_QUICK_ACTION_USED",
  "FAMILY_MEMBER_ADDED",
  "MEDICATION_ADDED",
  "EXERCISE_COMPLETED",
  "WIDGET_ADDED",
  "CHAT_CAMERA_USED",
];

// ── Chart color pool (for dynamically mapped series) ─────────────────────────
export const CHART_COLORS = [
  COLORS.purple[3], COLORS.blue[3], COLORS.teal[3],
  COLORS.amber[3],  COLORS.coral[3], COLORS.green[3],
  COLORS.purple[4], COLORS.blue[4],
];